import { Card, Table, TableContainer, TablePagination } from '@mui/material';
import { useState } from 'react';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import DynamicHeightComponent from 'src/utils/dynamicSize.component';
import NoApproval from 'src/assets/app-image/no-generated-posts.svg';
import GeneratedPostPendingApprovalGridBody from './generated-post-pending-approval-grid-body.component';
import GeneratedPostPendingApprovalGridHead from './generated-post-pending-approval-grid-head.component';

const GeneratedPostPendingApprovalGrid = ({ pendingApprovalList, handleReCallPendingApprovalPost, order, orderBy }) => {
  //Table Variables
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [height, setHeight] = useState(window.innerHeight - 110);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    let orderStr = isAsc ? 'desc' : 'asc';
    handleReCallPendingApprovalPost(property, orderStr);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };
  return (
    <>
      {pendingApprovalList && pendingApprovalList.length > 0 ? (
        <>
          <DynamicHeightComponent>
            <Scrollbar>
              <TableContainer
                sx={{
                  maxHeight: 'calc(90vh - 166px)',
                  minHeight: 'calc(94vh - 166px)',
                  height: height - 60,
                }}
              >
                <Table stickyHeader size="small">
                  <GeneratedPostPendingApprovalGridHead
                    pendingApprovalList={pendingApprovalList}
                    orderBy={orderBy}
                    order={order}
                    handleRequestSort={handleRequestSort}
                  ></GeneratedPostPendingApprovalGridHead>
                  <GeneratedPostPendingApprovalGridBody
                    pendingApprovalList={pendingApprovalList}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    handleReCallPendingApprovalPost={handleReCallPendingApprovalPost}
                  ></GeneratedPostPendingApprovalGridBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                rowsPerPageOptions={[10, 20, 30, 50]}
                count={pendingApprovalList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Scrollbar>
          </DynamicHeightComponent>
        </>
      ) : (
        <Card
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 150px)',
            maxHeight: 'calc(100vh - 150px)',
          }}
        >
          <img
            src={NoApproval}
            style={{ width: '50%', height: '50%', maxWidth: '50%', maxHeight: '50%' }}
            alt="No Pending Approval"
          />
        </Card>
      )}
    </>
  );
};
export default GeneratedPostPendingApprovalGrid;
